// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../firebase';

const ProtectedRoute = ({ children }) => {
  const user = auth.currentUser; // Verifica se o usuário está autenticado
  if (!user) {
    return <Navigate to="/admin" replace />; // Redireciona para o login se não estiver autenticado
  }
  return children; // Renderiza o componente protegido
};

export default ProtectedRoute;